var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInappVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 57,
    viewBox: "0 0 45 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 56,
    rx: 1.5,
    fill: "#F0F2F4",
    stroke: "#DCE0E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 21,
    height: 25,
    rx: 0.718002,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4189 37.8711L33.148 38.7356C33.0061 38.8001 32.9028 38.9549 32.9028 39.1098V41.2775C32.9028 41.4323 32.9932 41.5872 33.148 41.6517L35.4189 42.5162C35.6899 42.6452 35.9996 42.4388 35.9996 42.142V38.2453C35.9996 37.9485 35.6899 37.755 35.4189 37.8711Z",
    fill: "#99A9B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7677 36.7097H24.8645C24.3871 36.7097 24 37.0968 24 37.5742V42.8129C24 43.2903 24.3871 43.6774 24.8645 43.6774H31.7677C32.2451 43.6774 32.6322 43.2903 32.6322 42.8129V37.5742C32.6451 37.0968 32.2451 36.7097 31.7677 36.7097ZM29.5871 40.4258L27.6774 41.7032C27.4838 41.8323 27.2387 41.6903 27.2387 41.471V38.9162C27.2387 38.6839 27.4967 38.5549 27.6774 38.6839L29.5871 39.9613C29.7548 40.0645 29.7548 40.3226 29.5871 40.4258Z",
    fill: "#99A9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInappVideos);
export default __webpack_public_path__ + "static/media/inapp_videos.28aade219abec18793a55d98fce76907.svg";
export { ForwardRef as ReactComponent };